import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.contractAdmin, action) => {
  switch (action.type) {
    case types.SET_CONTRACT_ADMIN_NAVIGATION: {
      return {
        ...state,
        navItems: action.navItems,
      };
    }
    case types.GET_CONTRACT_ADMIN_DEFINITION_FAILURE: {
      return {
        ...state,
        definition: {
          ...state.definition,
          loading: false,
          error: true,
        },
      };
    }
    case types.RESET_CA_QUERY_ON_SEARCH_SORT: {
      return {
        ...state,
        definition: {
          ...state.definition,
          response: {
            totalPages: 1,
            currentPage: 1,
            hasMorePages: false,
            data: [],
          },
        },
      };
    }
    case types.GET_CA_DEFINITION_REQUEST: {
      return {
        ...state,
        definition: {
          ...state.definition,
          loading: true,
          error: false,
        },
      };
    }

    case types.GET_ACCOUNTS_LOCATIONS: {
      return {
        ...state,
        loading: false,
        locations: action.payload.data,
      };
    }
    case types.SET_CA_TABLE_QUERY: {
      return {
        ...state,
        definition: {
          ...state.definition,
          query: action.query,
          response: {
            ...state.definition.response,
            hasMorePages: false,
          },
        },
      };
    }

    case types.SET_ADD_NEW_FLAG: {
      return {
        ...state,
        addNewFlag: action.value,
      };
    }
    case types.SET_ADD_NEW_ENTITLEMENT_FLAG: {
      return {
        ...state,
        addNewEntitlement: action.value,
      };
    }
    case types.CA_SUMMARY: {
      return {
        ...state,
        isSummary: action.value,
      };
    }
    case types.SET_EDIT_ENTITLEMENT_FLAG: {
      return {
        ...state,
        editEntitlement: action.value,
      };
    }
    case types.SET_ENTITLEMENT_ID: {
      return {
        ...state,
        selectedEntitlementId: action.value,
      };
    }

    case types.SET_SELECTED_CONTRACT_ID: {
      return {
        ...state,
        selectedContractId: action.payload,
      };
    }

    case types.SET_SELECTED_LOCATION_ID: {
      return {
        ...state,
        selectedLocationId: action.payload,
      };
    }

    case types.SET_CONTRACT_EDIT_DATA: {
      return {
        ...state,
        addAccount: action.payload,
        editedAccountData: action.payload,
      };
    }

    case types.SET_EDITED_ACCOUNT_DATA: {
      return {
        ...state,
        editedAccountData: action.payload,
      };
    }
    case types.RESET_ADD_ACCOUNT_FORM: {
      return {
        ...state,
        addAccount: {
          accountId: '',
          accountName: '',
          accountType: 'STANDARD',
          industryTypeDesc: '',
          activeStatus: 'Y',
          accountLinkType: 'No Link',
          parentAccountId: null,
          contracts: [
            {
              accessedBasedOn: 'NATIONALSTUDY',
              univIpAddressType: '',
              univIpAddresses: [''],
              universityBackData: '',
              lastNationalStudy: '',
              studyStart: '',
              studyEnd: '',
              optInDate: '',
              optOutDate: '',
              contractNumber: '',
              contractName: '',
              status: 'A',
              statusDate: '',
              contractStart: '',
              contractEnd: '',
              notes: '',
              documents: '',
              documentId: '',
              address: {
                zipCode: '',
                phone: '',
                internalContact: '',
                country: '',
                state: '',
                streetAddress: '',
                apt: '',
                city: '',
              },
              // contacts: []
            },
          ],
          locations: [
            // {
            //   locationName: '',
            //   companyName: '',
            //   city: '',
            //   state: '',
            //   contactEmail: '',
            //   contactName: '',
            // },
          ],
          id: '',
        },
      };
    }
    case types.SET_UNSAVED_CHANGE_FLAG: {
      return {
        ...state,
        addNewFormUnsavedChangeFlag: action.payload,
      };
    }
    // case types.SET_EDITED_ACCOUNT_DATA: {
    //   return {
    //     ...state,
    //     editedAccountData: action.payload,
    //   }
    // }

    case types.GET_CONTRACT_ADMIN_DEFINITION_SUCCESS: {
      return {
        ...state,
        definition: {
          ...state.definition,
          loading: false,
          error: false,
          response: action.response,
          hasDefinition:
            state.definition.hasDefinition || action.response.data.length > 0,
        },
      };
    }
    case types.SET_ENT_UNSAVED_CHANGES_FLAG: {
      return {
        ...state,
        hasEntChanged: action.payload,
      };
    }
    case types.FETCH_MIDDLE_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        middleData: action.payload,
      };
    case types.FETCH_STUDY_DATA:
      return {
        ...state,
        isLoading: false,
        entStudies: action.payload,
      };

    case types.FETCH_SELECTED_LOCATION:
      return {
        ...state,
        isLoading: false,
        selectedLocations: action.payload,
      };
    case types.SET_SIMMONS_LOCAL_MARKETS: {
      return {
        ...state,
        simmonsLocalMarkets: action.payload,
      };
    }
    case types.SET_MEMRI_USERS: {
      return {
        ...state,
        isLoading: false,
        memriUsers: action.payload,
      };
    }
    case types.SET_MRI_TOP_MARKETS: {
      return {
        ...state,
        isLoading: false,
        mriTopMarkets: action.payload,
      };
    }
    case types.SET_EDIT_ENT_NAME: {
      return {
        ...state,
        isLoading: false,
        editEntName: action.payload,
      };
    }
    case types.SET_EDIT_ENT_MARKETS: {
      return {
        ...state,
        isLoading: false,
        editEntMarkets: action.payload,
      };
    }
    case types.SET_EDIT_ENT_MEMRI: {
      return {
        ...state,
        isLoading: false,
        editEntMemri: action.payload,
      };
    }
    case types.FETCH_PROP_CODES: {
      return {
        ...state,
        isLoading: false,
        propCodes: action.payload,
      };
    }

    case types.SET_PROP_CODE_TYPES: {
      return {
        ...state,
        isLoading: false,
        propCodeTypes: action.payload,
      };
    }
    case types.SET_EDIT_PROP_CODE: {
      return {
        ...state,
        isLoading: false,
        editSelectedPropCode: action.payload,
      };
    }
    case types.SET_EDIT_MRI_MARKET: {
      return {
        ...state,
        isLoading: false,
        editSelectedMRIMarket: action.payload,
      };
    }
    case types.SET_EDIT_MEMRI_USER: {
      return {
        ...state,
        isLoading: false,
        editSelectedMEMRIUser: action.payload,
      };
    }
    default:
      return state;
  }
};
